function Sponsors() {
  return (
    <section id="sponsors" className="w-full bg-[#ffe5ba] py-16 md:py-24">
      <h2 className="text-center text-[clamp(36px,6vw,80px)] font-bold font-spenbebgame text-[#5d0801] mb-12">
        SPONSORS
      </h2>
      <div className="flex items-center justify-center gap-8 px-8 max-w-6xl mx-auto">
        <img
          src="/images/cashier_cat.svg"
          alt="Cashier Cat"
          className="hidden md:block h-[clamp(150px,20vw,300px)] w-auto object-contain"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 items-center justify-items-center gap-8 md:gap-16">
        <a href="https://www.tavily.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/tavily.png"
            alt="Tavily"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://elevenlabs.io/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/elevenlabs-logo-black.svg"
            alt="ElevenLabs"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://featherless.ai/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/featherless-full-original.svg"
            alt="Featherless AI"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://lovable.dev/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/lovable-dark-png.png"
            alt="Lovable"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.redbull.com/us-en" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/redbull-logo-png-transparent.png"
            alt="Red Bull"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.bloomberg.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/bloomberg.png"
            alt="Bloomberg"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://tunerbench.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/tunerbench-wordmark.svg"
            alt="TunerBench"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://girlswhocode.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/Girls_Who_Code_Logo.png"
            alt="Girls Who Code"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.prenoradynamics.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/Asset 6_4x.avif"
            alt="Prenora Dynamics"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.instagram.com/jjay.css/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/john_jay.png"
            alt="John Jay College"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.bcstudentgov.org/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/usg.png"
            alt="USG"
            className="h-[clamp(70px,16vw,150px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.canvascloud.ai/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/canvas-cloud-ai-standard-logo.svg"
            alt="Canvas Cloud AI"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://bastanyc.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/Basta-1.png"
            alt="Basta"
            className="h-[clamp(80px,18vw,170px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        <a href="https://www.brooklyncollegefoundation.org/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/sponsors/brooklyn_college_foundation_inc_logo.jpeg"
            alt="Brooklyn College Foundation"
            className="h-[clamp(60px,14vw,130px)] w-auto object-contain hover:opacity-80 transition-opacity"
          />
        </a>
        </div>
      </div>
    </section>
  );
}

export default Sponsors;
